import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const banner = new Restful(project, 'banner')

banner.webGet = function(data) {
  const url = project + 'banner/website'
  return http.get(url, data).then(res => {
    return res
  })
}
export default banner
